if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (this.dataset.mmFilterVariants === 'false') {
          const selectedMedia = this.dataset.mmHasVariantMedia === 'false' ? null : this.elements.viewer.querySelector('.is-active')?.dataset.mediaId;
          this.filterVariantMedia(selectedMedia);
        }
        if (!this.elements.thumbnails) return;
        this.elements.viewer.querySelectorAll('.slider-buttons button').forEach((source) => {
          const arrow = source.cloneNode(true);
          arrow.className = `mm-gallery-arrow mm-gallery-arrow--${source.name}`;
          arrow.disabled = false;
          arrow.addEventListener('click', () => {
            const items = [...this.elements.thumbnails.querySelectorAll('[data-target]')].filter((item) => item.offsetWidth > 0);
            const current = items.findIndex((item) => item.querySelector('button').hasAttribute('aria-current'));
            const step = source.name === 'next' ? 1 : -1;
            const target = items[(current + step + items.length) % items.length];
            if (target) this.setActiveMedia(target.dataset.target, false);
          });
          arrow.hidden = this.dataset.mmFilterVariants === 'false' && this.visibleMediaIds?.size < 2;
          this.elements.viewer.append(arrow);
        });


        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      filterVariantMedia(mediaId) {
        const prefix = this.id.replace('MediaGallery-', '') + '-';
        const requested = (this.dataset.mmVariantMedia || '').split(',').filter(Boolean).map((id) => prefix + id);
        if (mediaId && !requested.includes(mediaId)) requested.unshift(mediaId);
        this.visibleMediaIds = new Set(requested.filter((id) => this.elements.viewer.querySelector('[data-media-id="' + id + '"]')));
        this.querySelector('[data-mm-gallery-empty]')?.classList.toggle('hidden', this.visibleMediaIds.size > 0);
        this.elements.thumbnails?.classList.toggle('hidden', this.visibleMediaIds.size === 0);
        this.elements.viewer.querySelectorAll('.slider-buttons').forEach((controls) => controls.classList.toggle('hidden', this.visibleMediaIds.size < 2));
        this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((item) => {
          item.classList.toggle('mm-media-excluded', !this.visibleMediaIds.has(item.dataset.mediaId));
        });
        this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((item) => {
          item.classList.toggle('mm-media-excluded', !this.visibleMediaIds.has(item.dataset.target));
        });
        this.elements.viewer.querySelectorAll('.mm-gallery-arrow').forEach((arrow) => { arrow.hidden = this.visibleMediaIds.size < 2; });
        this.elements.viewer.resetPages?.();
        this.elements.thumbnails?.resetPages?.();
      }

      setActiveMedia(mediaId, prepend) {
        if (prepend && this.dataset.mmFilterVariants === 'false') this.filterVariantMedia(mediaId);
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
